// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-container {
  min-height: calc(100vh - 72px);
  background: var(--background-color);
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 40px;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
}

.preview-title-section {
  display: flex;
  align-items: center;
  gap: 16px;
}

.preview-header h1 {
  font-size: 24px;
  font-weight: 600;
  color: #000;
  margin: 0;
}

.btn-back {
  background: transparent;
  color: var(--button-color);
  border: 1px solid var(--button-color);
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.btn-back:hover {
  background: var(--button-color);
  color: white;
}

.preview-actions {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.preview-actions-separator {
  width: 1px;
  height: 24px;
  background: #d0d0d0;
  margin: 0 4px;
}

.btn-detection-help {
  background: transparent;
  color: var(--button-color);
  border: 1px solid var(--button-color);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-detection-help:hover {
  background: var(--button-color);
  color: white;
}

.btn-detection-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-download {
  background: var(--button-color);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.btn-download:hover {
  opacity: 0.9;
}

.download-error-msg {
  font-size: 12px;
  color: #c0392b;
  max-width: 260px;
  line-height: 1.4;
}

.btn-location {
  background: transparent;
  color: var(--button-color);
  border: 1px solid var(--button-color);
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-location:hover {
  background: var(--button-color);
  color: white;
}

.btn-close {
  background: transparent;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.btn-close:hover {
  background: var(--background-color);
}

.preview-content {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 20px;
  padding: 30px 40px;
  max-width: 1600px;
  margin: 0 auto;
}

.preview-content:has(.similar-panel-wrapper) {
  grid-template-columns: 320px 1fr 300px;
  max-width: 1800px;
}

.similar-panel-wrapper {
  min-width: 0;
}

.preview-sidebar {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.file-info-card,
.summary-card,
.invoice-card,
.image-preview-card {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.file-info-card h3,
.summary-card h3,
.invoice-card h3,
.image-preview-card h3 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #000;
}

.info-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 14px;
}

.info-item .label {
  color: #666;
  font-weight: 500;
}

.info-item .value {
  color: #000;
  text-align: right;
  max-width: 60%;
  word-break: break-word;
}

.hash-value {
  font-family: monospace;
  font-size: 12px;
}

.status-completed {
  color: #22c55e;
  font-weight: 600;
}

.preview-main {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.operations-section,
.dimensions-section {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.operations-section h2,
.dimensions-section h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 24px;
  color: #000;
}

.operations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
}

.operation-card {
  border: 1px solid #e0e0e0;
  padding: 20px;
  border-radius: 6px;
  background: #fafafa;
}

.operation-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.operation-number {
  background: var(--button-color);
  color: #fff;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.operation-macro {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.operation-card h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #000;
}

.operation-desc {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 12px;
}

.operation-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e0e0e0;
}

.detail-item {
  display: flex;
  font-size: 13px;
}

.detail-label {
  color: #666;
  min-width: 60px;
  font-weight: 500;
}

.dimensions-table {
  overflow-x: auto;
}

.dimensions-table table {
  width: 100%;
  border-collapse: collapse;
}

.dimensions-table th {
  background: var(--background-color);
  padding: 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #000;
  border-bottom: 2px solid #e0e0e0;
}

.dimensions-table td {
  padding: 12px;
  font-size: 13px;
  color: #000;
  border-bottom: 1px solid #f0f0f0;
}

.dim-type {
  font-weight: 500;
  text-transform: capitalize;
}

.dim-value {
  font-weight: 600;
}

.image-thumbnail {
  cursor: pointer;
  border-radius: 6px;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  background: var(--background-color);
}

.image-thumbnail:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.image-thumbnail img {
  width: 100%;
  height: auto;
  display: block;
  max-height: 400px;
  object-fit: contain;
}

.image-loading {
  padding: 60px 20px;
  text-align: center;
  color: #666;
  font-size: 14px;
  background: var(--background-color);
  border-radius: 6px;
}

.btn-detect-annotations {
  width: 100%;
  margin-top: 12px;
  padding: 10px 16px;
  border: 2px solid var(--button-color);
  border-radius: 8px;
  background: linear-gradient(135deg, var(--button-color), #1565c0);
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  letter-spacing: 0.3px;
}

.btn-detect-annotations:hover:not(:disabled) {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.btn-detect-annotations:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(8px);
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.image-modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  animation: zoomIn 0.2s ease;
}

@keyframes zoomIn {
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.image-modal-content img {
  max-width: 100%;
  max-height: 90vh;
  width: auto;
  height: auto;
  display: block;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.modal-close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #000;
  padding: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s ease;
}

.modal-close-btn:hover {
  background: #fff;
}

/* Categories Section - New Format */
.categories-section {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.categories-section h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 24px;
  color: #000;
}

.category-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 24px;
  overflow: hidden;
  background: #fafafa;
  transition: box-shadow 0.2s ease;
}

.category-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.category-header {
  background: var(--button-color);
  padding: 16px 24px;
}

.category-header h3 {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.category-general-info {
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background: #fff;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}

.info-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-label {
  font-size: 12px;
  color: #666;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.field-value {
  font-size: 15px;
  color: #000;
  font-weight: 600;
}

.category-array-section {
  padding: 24px;
  background: #fff;
}

.category-array-section:not(:last-child) {
  border-bottom: 1px solid #e0e0e0;
}

.category-array-section h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  color: var(--button-color);
  display: flex;
  align-items: center;
  gap: 8px;
}

.category-array-section h4::before {
  content: "▸";
  color: var(--button-color);
}

.array-items-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.array-item-card {
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.array-item-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: var(--button-color);
}

.array-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(90deg, #f0f0f0 0%, #fafafa 100%);
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
  color: var(--button-color);
  border-bottom: 1px solid #e0e0e0;
}

.item-page-badge {
  background: var(--button-color);
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
}

.array-item-details {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.array-item-field {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  font-size: 13px;
}

.item-label {
  color: #666;
  font-weight: 500;
  flex-shrink: 0;
  min-width: 100px;
}

.item-value {
  color: #000;
  font-weight: 600;
  text-align: right;
  word-break: break-word;
}

/* Empty state for categories */
.category-card:empty {
  display: none;
}

/* Simple array values (for primitive arrays like strings/numbers) */
.simple-array-values {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px;
}

.simple-value {
  background: #f5f5f5;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 13px;
  color: #333;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .info-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }

  .array-items-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
}

@media (max-width: 1200px) {
  .preview-content:has(.similar-panel-wrapper) {
    grid-template-columns: 280px 1fr 240px;
    max-width: 1600px;
  }
}

@media (max-width: 1000px) {
  .preview-content:has(.similar-panel-wrapper) {
    grid-template-columns: 240px 1fr 200px;
  }
}

@media (max-width: 768px) {
  .preview-content {
    grid-template-columns: 1fr;
  }

  .preview-content:has(.similar-panel-wrapper) {
    grid-template-columns: 1fr 180px;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .array-items-grid {
    grid-template-columns: 1fr;
  }
}

/* Multi-drawing tabs */
.drawing-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.drawing-tab {
  padding: 10px 20px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
}

.drawing-tab:hover {
  border-color: var(--button-color);
  color: var(--button-color);
}

.drawing-tab.active {
  background: var(--button-color);
  border-color: var(--button-color);
  color: #fff;
}

/* Multi-image grid for multiple drawing pages */
.multi-image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
}

.multi-image-item {
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
}

.multi-image-item:hover {
  border-color: var(--button-color);
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.multi-image-item.selected {
  border-color: var(--button-color);
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);
}

.multi-image-label {
  background: #f5f5f5;
  padding: 8px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #666;
}

.multi-image-item.selected .multi-image-label {
  background: var(--button-color);
  color: #fff;
}

.multi-image-item img {
  width: 100%;
  height: 100px;
  object-fit: contain;
  background: #fafafa;
}

.image-loading-small {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  font-size: 12px;
  color: #999;
}

/* Document data centered layout (when no machining operations) */
.preview-content.no-operations {
  grid-template-columns: 320px 1fr;
}

.preview-content.no-operations:has(.similar-panel-wrapper) {
  grid-template-columns: 320px 1fr 300px;
  max-width: 1800px;
}

.document-data-center {
  background: #fff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  max-width: 800px;
  margin: 0 auto;
}

.document-data-center h2 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 32px;
  color: #000;
  text-align: center;
  padding-bottom: 16px;
  border-bottom: 2px solid var(--button-color);
}

.document-data-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.document-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid var(--button-color);
}

.document-field.full-width {
  grid-column: 1 / -1;
}

.document-label {
  font-size: 12px;
  color: #666;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.document-value {
  font-size: 18px;
  color: #000;
  font-weight: 500;
  line-height: 1.4;
}

.document-value.notes {
  font-size: 14px;
  color: #444;
  font-weight: 400;
  line-height: 1.6;
}

.no-data-message {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}

.no-data-message p {
  margin: 8px 0;
  font-size: 16px;
}

@media (max-width: 768px) {
  .preview-content.no-operations {
    grid-template-columns: 1fr;
  }

  .preview-content.no-operations:has(.similar-panel-wrapper) {
    grid-template-columns: 1fr 180px;
  }

  .document-data-grid {
    grid-template-columns: 1fr;
  }

  .document-data-center {
    padding: 24px;
  }

  .document-value {
    font-size: 16px;
  }
}
/* NUBBI-94 — Autosave indicator en header preview */
.preview-autosave-status {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 12px;
  white-space: nowrap;
  min-width: 90px;
  text-align: center;
  letter-spacing: 0.2px;
}
.preview-autosave-status.status-saving { color: #1976d2; background: #e3f2fd; }
.preview-autosave-status.status-ok { color: #2e7d32; background: #e8f5e9; }
.preview-autosave-status.status-dirty { color: #b26a00; background: #fff4e0; }
.preview-autosave-status.status-error { color: #c33; background: #fee; }
.preview-autosave-status.status-idle { display: none; }

/* NUBBI-94 — Loading overlay sobre DetectionView */
.preview-body-wrapper {
  position: relative;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.preview-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: rgba(248, 250, 252, 0.95);
  backdrop-filter: blur(2px);
}
.preview-loading-spinner {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 3px solid #cfd8e3;
  border-top-color: #1976d2;
  animation: preview-spin 0.9s linear infinite;
}
.preview-loading-text {
  color: #555;
  font-size: 14px;
  font-weight: 500;
}
@keyframes preview-spin {
  to { transform: rotate(360deg); }
}

/* NUBBI-99 — Badge tipo de pieza (cónico/recto) */
.conical-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px 4px 10px;
  border-radius: 14px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  border: 1px solid transparent;
}
.conical-badge.conical-yes { background: #e8f4fd; border-color: #6cb4f0; color: #1565c0; }
.conical-badge.conical-no { background: #e8f5e9; border-color: #82c785; color: #2e7d32; }
.conical-badge.conical-unknown { background: #f5f5f5; border-color: #ccc; color: #777; }
.conical-badge .conical-label { font-weight: 600; }
.conical-badge .conical-select {
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #d4d9e3;
  border-radius: 6px;
  font-size: 11px;
  padding: 2px 4px;
  cursor: pointer;
}
.conical-badge .conical-select:disabled { cursor: wait; opacity: 0.6; }

/* Si la imagen del plano no se puede cargar (el archivo original vive en la carpeta
   del cliente y puede no responder), se avisa en una franja y se deja usar el resto
   del análisis, en vez de dejar el overlay de carga girando para siempre. */
.preview-image-error {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 40px;
  background: #fff8e6;
  border-bottom: 1px solid #f0e2bd;
  color: #8a6d1f;
  font-size: 13px;
}

.preview-image-error-text { color: #6b5412; font-weight: 500; }
.preview-image-error-hint { color: #9a834a; }

.preview-image-error .preview-image-error-retry {
  margin-left: auto;
  padding: 5px 14px;
  border: 1px solid #e0cf9f;
  border-radius: 7px;
  background: #fff;
  color: #6b5412;
  font-size: 13px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.preview-image-error .preview-image-error-retry:hover {
  border-color: #c9ab63;
  background: #fffdf7;
}

@media (max-width: 760px) {
  .preview-image-error { padding: 10px 16px; }
  .preview-image-error .preview-image-error-retry { margin-left: 0; }
}
`, "",{"version":3,"sources":["webpack://./src/components/History/AnalysisPreview.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;EAIE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;;;;EAIE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,iEAAiE;EACjE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4DAA4D;EAC5D,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;AACf;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE;IACE,4DAA4D;EAC9D;;EAEA;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;AACb;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA,iEAAiE;AACjE;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;AACA,oDAAoD;AACpD;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;AACA,yCAAyC,cAAc,EAAE,mBAAmB,EAAE;AAC9E,qCAAqC,cAAc,EAAE,mBAAmB,EAAE;AAC1E,wCAAwC,cAAc,EAAE,mBAAmB,EAAE;AAC7E,wCAAwC,WAAW,EAAE,gBAAgB,EAAE;AACvE,uCAAuC,aAAa,EAAE;;AAEtD,mDAAmD;AACnD;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,qCAAqC;EACrC,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,kDAAkD;AAClD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA,6BAA6B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACzF,4BAA4B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACxF,iCAAiC,mBAAmB,EAAE,kBAAkB,EAAE,WAAW,EAAE;AACvF,gCAAgC,gBAAgB,EAAE;AAClD;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,0CAA0C,YAAY,EAAE,YAAY,EAAE;;AAEtE;;4EAE4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA,4BAA4B,cAAc,EAAE,gBAAgB,EAAE;AAC9D,4BAA4B,cAAc,EAAE;;AAE5C;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB,kBAAkB,EAAE;EAC3C,kDAAkD,cAAc,EAAE;AACpE","sourcesContent":[".preview-container {\n  min-height: calc(100vh - 72px);\n  background: var(--background-color);\n}\n\n.preview-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 30px 40px;\n  background: #fff;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.preview-title-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.preview-header h1 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #000;\n  margin: 0;\n}\n\n.btn-back {\n  background: transparent;\n  color: var(--button-color);\n  border: 1px solid var(--button-color);\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.btn-back:hover {\n  background: var(--button-color);\n  color: white;\n}\n\n.preview-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.preview-actions-separator {\n  width: 1px;\n  height: 24px;\n  background: #d0d0d0;\n  margin: 0 4px;\n}\n\n.btn-detection-help {\n  background: transparent;\n  color: var(--button-color);\n  border: 1px solid var(--button-color);\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-detection-help:hover {\n  background: var(--button-color);\n  color: white;\n}\n\n.btn-detection-save:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-download {\n  background: var(--button-color);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n.btn-download:hover {\n  opacity: 0.9;\n}\n\n.download-error-msg {\n  font-size: 12px;\n  color: #c0392b;\n  max-width: 260px;\n  line-height: 1.4;\n}\n\n.btn-location {\n  background: transparent;\n  color: var(--button-color);\n  border: 1px solid var(--button-color);\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-location:hover {\n  background: var(--button-color);\n  color: white;\n}\n\n.btn-close {\n  background: transparent;\n  border: none;\n  font-size: 28px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.btn-close:hover {\n  background: var(--background-color);\n}\n\n.preview-content {\n  display: grid;\n  grid-template-columns: 320px 1fr;\n  gap: 20px;\n  padding: 30px 40px;\n  max-width: 1600px;\n  margin: 0 auto;\n}\n\n.preview-content:has(.similar-panel-wrapper) {\n  grid-template-columns: 320px 1fr 300px;\n  max-width: 1800px;\n}\n\n.similar-panel-wrapper {\n  min-width: 0;\n}\n\n.preview-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.file-info-card,\n.summary-card,\n.invoice-card,\n.image-preview-card {\n  background: #fff;\n  padding: 24px;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.file-info-card h3,\n.summary-card h3,\n.invoice-card h3,\n.image-preview-card h3 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  color: #000;\n}\n\n.info-item {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  font-size: 14px;\n}\n\n.info-item .label {\n  color: #666;\n  font-weight: 500;\n}\n\n.info-item .value {\n  color: #000;\n  text-align: right;\n  max-width: 60%;\n  word-break: break-word;\n}\n\n.hash-value {\n  font-family: monospace;\n  font-size: 12px;\n}\n\n.status-completed {\n  color: #22c55e;\n  font-weight: 600;\n}\n\n.preview-main {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.operations-section,\n.dimensions-section {\n  background: #fff;\n  padding: 30px;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.operations-section h2,\n.dimensions-section h2 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 24px;\n  color: #000;\n}\n\n.operations-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 20px;\n}\n\n.operation-card {\n  border: 1px solid #e0e0e0;\n  padding: 20px;\n  border-radius: 6px;\n  background: #fafafa;\n}\n\n.operation-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.operation-number {\n  background: var(--button-color);\n  color: #fff;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.operation-macro {\n  font-size: 12px;\n  color: #666;\n  font-weight: 500;\n}\n\n.operation-card h4 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #000;\n}\n\n.operation-desc {\n  font-size: 13px;\n  color: #666;\n  line-height: 1.5;\n  margin-bottom: 12px;\n}\n\n.operation-details {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.detail-item {\n  display: flex;\n  font-size: 13px;\n}\n\n.detail-label {\n  color: #666;\n  min-width: 60px;\n  font-weight: 500;\n}\n\n.dimensions-table {\n  overflow-x: auto;\n}\n\n.dimensions-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.dimensions-table th {\n  background: var(--background-color);\n  padding: 12px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #000;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.dimensions-table td {\n  padding: 12px;\n  font-size: 13px;\n  color: #000;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.dim-type {\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.dim-value {\n  font-weight: 600;\n}\n\n.image-thumbnail {\n  cursor: pointer;\n  border-radius: 6px;\n  overflow: hidden;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  background: var(--background-color);\n}\n\n.image-thumbnail:hover {\n  transform: scale(1.02);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.image-thumbnail img {\n  width: 100%;\n  height: auto;\n  display: block;\n  max-height: 400px;\n  object-fit: contain;\n}\n\n.image-loading {\n  padding: 60px 20px;\n  text-align: center;\n  color: #666;\n  font-size: 14px;\n  background: var(--background-color);\n  border-radius: 6px;\n}\n\n.btn-detect-annotations {\n  width: 100%;\n  margin-top: 12px;\n  padding: 10px 16px;\n  border: 2px solid var(--button-color);\n  border-radius: 8px;\n  background: linear-gradient(135deg, var(--button-color), #1565c0);\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  letter-spacing: 0.3px;\n}\n\n.btn-detect-annotations:hover:not(:disabled) {\n  opacity: 0.9;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.btn-detect-annotations:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.image-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(8px);\n  padding: 20px;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.image-modal-content {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  animation: zoomIn 0.2s ease;\n}\n\n@keyframes zoomIn {\n  from {\n    transform: scale(0.9);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.image-modal-content img {\n  max-width: 100%;\n  max-height: 90vh;\n  width: auto;\n  height: auto;\n  display: block;\n  border-radius: 8px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.modal-close-btn {\n  position: absolute;\n  top: -40px;\n  right: 0;\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #000;\n  padding: 8px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background 0.2s ease;\n}\n\n.modal-close-btn:hover {\n  background: #fff;\n}\n\n/* Categories Section - New Format */\n.categories-section {\n  background: #fff;\n  padding: 30px;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.categories-section h2 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 24px;\n  color: #000;\n}\n\n.category-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  margin-bottom: 24px;\n  overflow: hidden;\n  background: #fafafa;\n  transition: box-shadow 0.2s ease;\n}\n\n.category-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.category-header {\n  background: var(--button-color);\n  padding: 16px 24px;\n}\n\n.category-header h3 {\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.category-general-info {\n  padding: 20px 24px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #fff;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.info-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.field-label {\n  font-size: 12px;\n  color: #666;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.field-value {\n  font-size: 15px;\n  color: #000;\n  font-weight: 600;\n}\n\n.category-array-section {\n  padding: 24px;\n  background: #fff;\n}\n\n.category-array-section:not(:last-child) {\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.category-array-section h4 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 16px;\n  color: var(--button-color);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.category-array-section h4::before {\n  content: \"▸\";\n  color: var(--button-color);\n}\n\n.array-items-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.array-item-card {\n  background: #f8f9fa;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  overflow: hidden;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.array-item-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: var(--button-color);\n}\n\n.array-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(90deg, #f0f0f0 0%, #fafafa 100%);\n  padding: 10px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--button-color);\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.item-page-badge {\n  background: var(--button-color);\n  color: white;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.array-item-details {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.array-item-field {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 12px;\n  font-size: 13px;\n}\n\n.item-label {\n  color: #666;\n  font-weight: 500;\n  flex-shrink: 0;\n  min-width: 100px;\n}\n\n.item-value {\n  color: #000;\n  font-weight: 600;\n  text-align: right;\n  word-break: break-word;\n}\n\n/* Empty state for categories */\n.category-card:empty {\n  display: none;\n}\n\n/* Simple array values (for primitive arrays like strings/numbers) */\n.simple-array-values {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 12px;\n}\n\n.simple-value {\n  background: #f5f5f5;\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 13px;\n  color: #333;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1024px) {\n  .info-grid {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  }\n\n  .array-items-grid {\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  }\n}\n\n@media (max-width: 1200px) {\n  .preview-content:has(.similar-panel-wrapper) {\n    grid-template-columns: 280px 1fr 240px;\n    max-width: 1600px;\n  }\n}\n\n@media (max-width: 1000px) {\n  .preview-content:has(.similar-panel-wrapper) {\n    grid-template-columns: 240px 1fr 200px;\n  }\n}\n\n@media (max-width: 768px) {\n  .preview-content {\n    grid-template-columns: 1fr;\n  }\n\n  .preview-content:has(.similar-panel-wrapper) {\n    grid-template-columns: 1fr 180px;\n  }\n\n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .array-items-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Multi-drawing tabs */\n.drawing-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.drawing-tab {\n  padding: 10px 20px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  background: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  color: #666;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.drawing-tab:hover {\n  border-color: var(--button-color);\n  color: var(--button-color);\n}\n\n.drawing-tab.active {\n  background: var(--button-color);\n  border-color: var(--button-color);\n  color: #fff;\n}\n\n/* Multi-image grid for multiple drawing pages */\n.multi-image-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 12px;\n}\n\n.multi-image-item {\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.multi-image-item:hover {\n  border-color: var(--button-color);\n  transform: scale(1.02);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.multi-image-item.selected {\n  border-color: var(--button-color);\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);\n}\n\n.multi-image-label {\n  background: #f5f5f5;\n  padding: 8px;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n}\n\n.multi-image-item.selected .multi-image-label {\n  background: var(--button-color);\n  color: #fff;\n}\n\n.multi-image-item img {\n  width: 100%;\n  height: 100px;\n  object-fit: contain;\n  background: #fafafa;\n}\n\n.image-loading-small {\n  width: 100%;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f5f5f5;\n  font-size: 12px;\n  color: #999;\n}\n\n/* Document data centered layout (when no machining operations) */\n.preview-content.no-operations {\n  grid-template-columns: 320px 1fr;\n}\n\n.preview-content.no-operations:has(.similar-panel-wrapper) {\n  grid-template-columns: 320px 1fr 300px;\n  max-width: 1800px;\n}\n\n.document-data-center {\n  background: #fff;\n  padding: 40px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.document-data-center h2 {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 32px;\n  color: #000;\n  text-align: center;\n  padding-bottom: 16px;\n  border-bottom: 2px solid var(--button-color);\n}\n\n.document-data-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 24px;\n}\n\n.document-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border-left: 4px solid var(--button-color);\n}\n\n.document-field.full-width {\n  grid-column: 1 / -1;\n}\n\n.document-label {\n  font-size: 12px;\n  color: #666;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.document-value {\n  font-size: 18px;\n  color: #000;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.document-value.notes {\n  font-size: 14px;\n  color: #444;\n  font-weight: 400;\n  line-height: 1.6;\n}\n\n.no-data-message {\n  text-align: center;\n  padding: 40px 20px;\n  color: #666;\n}\n\n.no-data-message p {\n  margin: 8px 0;\n  font-size: 16px;\n}\n\n@media (max-width: 768px) {\n  .preview-content.no-operations {\n    grid-template-columns: 1fr;\n  }\n\n  .preview-content.no-operations:has(.similar-panel-wrapper) {\n    grid-template-columns: 1fr 180px;\n  }\n\n  .document-data-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .document-data-center {\n    padding: 24px;\n  }\n\n  .document-value {\n    font-size: 16px;\n  }\n}\n/* NUBBI-94 — Autosave indicator en header preview */\n.preview-autosave-status {\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 12px;\n  white-space: nowrap;\n  min-width: 90px;\n  text-align: center;\n  letter-spacing: 0.2px;\n}\n.preview-autosave-status.status-saving { color: #1976d2; background: #e3f2fd; }\n.preview-autosave-status.status-ok { color: #2e7d32; background: #e8f5e9; }\n.preview-autosave-status.status-dirty { color: #b26a00; background: #fff4e0; }\n.preview-autosave-status.status-error { color: #c33; background: #fee; }\n.preview-autosave-status.status-idle { display: none; }\n\n/* NUBBI-94 — Loading overlay sobre DetectionView */\n.preview-body-wrapper {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n.preview-loading-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 50;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  background: rgba(248, 250, 252, 0.95);\n  backdrop-filter: blur(2px);\n}\n.preview-loading-spinner {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  border: 3px solid #cfd8e3;\n  border-top-color: #1976d2;\n  animation: preview-spin 0.9s linear infinite;\n}\n.preview-loading-text {\n  color: #555;\n  font-size: 14px;\n  font-weight: 500;\n}\n@keyframes preview-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* NUBBI-99 — Badge tipo de pieza (cónico/recto) */\n.conical-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px 4px 10px;\n  border-radius: 14px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  border: 1px solid transparent;\n}\n.conical-badge.conical-yes { background: #e8f4fd; border-color: #6cb4f0; color: #1565c0; }\n.conical-badge.conical-no { background: #e8f5e9; border-color: #82c785; color: #2e7d32; }\n.conical-badge.conical-unknown { background: #f5f5f5; border-color: #ccc; color: #777; }\n.conical-badge .conical-label { font-weight: 600; }\n.conical-badge .conical-select {\n  background: rgba(255, 255, 255, 0.8);\n  border: 1px solid #d4d9e3;\n  border-radius: 6px;\n  font-size: 11px;\n  padding: 2px 4px;\n  cursor: pointer;\n}\n.conical-badge .conical-select:disabled { cursor: wait; opacity: 0.6; }\n\n/* Si la imagen del plano no se puede cargar (el archivo original vive en la carpeta\n   del cliente y puede no responder), se avisa en una franja y se deja usar el resto\n   del análisis, en vez de dejar el overlay de carga girando para siempre. */\n.preview-image-error {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 10px 40px;\n  background: #fff8e6;\n  border-bottom: 1px solid #f0e2bd;\n  color: #8a6d1f;\n  font-size: 13px;\n}\n\n.preview-image-error-text { color: #6b5412; font-weight: 500; }\n.preview-image-error-hint { color: #9a834a; }\n\n.preview-image-error .preview-image-error-retry {\n  margin-left: auto;\n  padding: 5px 14px;\n  border: 1px solid #e0cf9f;\n  border-radius: 7px;\n  background: #fff;\n  color: #6b5412;\n  font-size: 13px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.preview-image-error .preview-image-error-retry:hover {\n  border-color: #c9ab63;\n  background: #fffdf7;\n}\n\n@media (max-width: 760px) {\n  .preview-image-error { padding: 10px 16px; }\n  .preview-image-error .preview-image-error-retry { margin-left: 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
